import React from 'react';
import { motion } from 'framer-motion';
import { Target, AlertTriangle, CheckCircle2, XCircle } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function TargetAudience() {
  const forWho = ['Kinesiólogos y fisioterapeutas', 'Médicos traumatólogos', 'Profesionales en rehabilitación', 'Estudiantes avanzados', 'Clínicas y centros de salud'];
  const notForWho = ['Personas que no aplican lo que aprenden', 'Profesionales que no quieren mejorar', 'Quienes prefieren seguir improvisando'];
  return <section className="py-20 px-4 bg-slate-900 border-y border-slate-800" data-id="element-154">
      <div className="max-w-5xl mx-auto" data-id="element-155">
        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-156">
          {/* Para quién es */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-950 p-8 rounded-3xl border border-teal-900/50 relative overflow-hidden" data-id="element-157">
            <div className="absolute top-0 right-0 w-32 h-32 bg-teal-500/10 rounded-full blur-2xl" data-id="element-158"></div>
            <div className="flex items-center gap-3 mb-8 relative z-10" data-id="element-159">
              <Target className="w-8 h-8 text-teal-400" data-id="element-160" />
              <h2 className="text-3xl font-bold text-white" data-id="element-161">¿Para quién es?</h2>
            </div>
            <ul className="space-y-4 mb-8 relative z-10" data-id="element-162">
              {forWho.map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-163">
                  <CheckCircle2 className="w-6 h-6 text-teal-500 flex-shrink-0" data-id="element-164" />
                  <span className="text-slate-200 text-lg" data-id="element-165">{item}</span>
                </li>)}
            </ul>
            <div className="bg-teal-950/50 p-4 rounded-xl border border-teal-900 relative z-10" data-id="element-166">
              <p className="font-bold text-teal-400 text-center" data-id="element-167">
                👉 Si querés trabajar mejor, esto es para vos.
              </p>
            </div>
          </motion.div>

          {/* Para quién NO es */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-950 p-8 rounded-3xl border border-red-900/30 relative overflow-hidden" data-id="element-168">
            <div className="absolute top-0 right-0 w-32 h-32 bg-red-500/5 rounded-full blur-2xl" data-id="element-169"></div>
            <div className="flex items-center gap-3 mb-8 relative z-10" data-id="element-170">
              <AlertTriangle className="w-8 h-8 text-red-500" data-id="element-171" />
              <h2 className="text-3xl font-bold text-white" data-id="element-172">
                ¿Para quién NO es?
              </h2>
            </div>
            <ul className="space-y-4 relative z-10" data-id="element-173">
              {notForWho.map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-174">
                  <XCircle className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-175" />
                  <span className="text-slate-300 text-lg" data-id="element-176">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-16" data-id="element-177">
          <CTAButton data-id="element-178" />
        </motion.div>
      </div>
    </section>;
}